import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "flag-icon-css-dk",
  viewBox: "0 0 640 480",
  width: "50%"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#c8102e",
  d: "M0 0h640.1v480H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M205.7 0h68.6v480h-68.6z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 205.7h640.1v68.6H0z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default render